/** Shared visual constants for Shura Nexus components. */

export const CONNECTION_LEGEND = [
  { kind: 'investment',       label: 'Investment',       color: '#8B3FC5' },
  { kind: 'board_membership', label: 'Board Membership', color: '#3B82F6' },
  { kind: 'partnership',      label: 'Partnership',      color: '#7C3AED' },
  { kind: 'mentor',           label: 'Mentor',           color: '#06B6D4' },
  { kind: 'supplier',         label: 'Supplier',         color: '#10B981' },
  { kind: 'government',       label: 'Government',       color: '#FFFFFF' },
];
